import { core_v1_DataSourceSpec } from '@antimatterhq/asl-api-ts-v1';
import { Fieldset } from '@antimatterhq/ui/components/fieldset';
import Spacer from '@antimatterhq/ui/components/spacer';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { FlagSet } from '@antimatterhq/ui/utils/flags';

type JsonExtract = NonNullable<
  NonNullable<
    NonNullable<core_v1_DataSourceSpec['silver']>['preTransform']
  >['utils']
>['jsonExtract'];

export const JsonExtractReview = ({
  jsonExtract,
}: {
  jsonExtract: JsonExtract;
}) => {
  const { enableJsonExtraction } = useFlags<FlagSet>();
  if (!enableJsonExtraction) {
    return null;
  }

  if (!jsonExtract?.length) {
    return (
      <div>
        <Fieldset.Field>
          <Fieldset.Label>No JSON Extraction</Fieldset.Label>
        </Fieldset.Field>
      </div>
    );
  }
  return (
    <div>
      <Fieldset.Field>
        <Fieldset.Label>JSON Extraction</Fieldset.Label>
      </Fieldset.Field>
      <Fieldset.List>
        {jsonExtract?.map((extract, i) => (
          <div key={extract.source}>
            {i !== 0 && <Spacer size="lg" />}
            <Fieldset.Field>
              <Fieldset.Label>Column to extract:</Fieldset.Label>
              <Fieldset.Value>{extract.source}</Fieldset.Value>
            </Fieldset.Field>
            <Fieldset.Field>
              <Fieldset.Label>Field(s) to omit:</Fieldset.Label>
              <Fieldset.Value>
                {extract.omitFields?.map((f) => f).join(', ')}
              </Fieldset.Value>
            </Fieldset.Field>
            <Fieldset.Field>
              <Fieldset.Label>
                Prefix for colliding column names:
              </Fieldset.Label>
              <Fieldset.Value>{extract.duplicatePrefix}</Fieldset.Value>
            </Fieldset.Field>
            <Fieldset.Field>
              <Fieldset.Label>Destination column:</Fieldset.Label>
              <Fieldset.Value>{extract.embedColumn}</Fieldset.Value>
            </Fieldset.Field>
          </div>
        ))}
      </Fieldset.List>
    </div>
  );
};
